import { Link } from "react-router-dom";
import { FounderActionIcon, type FounderActionIconKind } from "./FounderActionIcons";

type FounderIconButtonProps = {
  kind: FounderActionIconKind;
  label: string;
  onClick?: () => void;
  disabled?: boolean;
  type?: "button" | "submit";
};

export function FounderIconButton({
  kind,
  label,
  onClick,
  disabled = false,
  type = "button",
}: FounderIconButtonProps) {
  return (
    <button
      aria-label={label}
      className={[
        "oac-founder-icon-btn",
        kind === "publish" ? "oac-founder-icon-btn--publish" : "",
      ]
        .filter(Boolean)
        .join(" ")}
      disabled={disabled}
      onClick={onClick}
      title={label}
      type={type}
    >
      <FounderActionIcon className="oac-founder-icon-btn__icon" kind={kind} />
    </button>
  );
}

export function FounderIconLink({
  kind,
  label,
  to,
}: {
  kind: FounderActionIconKind;
  label: string;
  to: string;
}) {
  return (
    <Link aria-label={label} className="oac-founder-icon-btn" title={label} to={to}>
      <FounderActionIcon className="oac-founder-icon-btn__icon" kind={kind} />
    </Link>
  );
}
